<div class="configurationContainer ">
    <!-- <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span> -->
  
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">Configuration</span></h5>
        </div>
        <div class="col px-0">
       </div>
    </div>
    </div>
      <div class="container-fluid align-items-start configContents">
    <!-- <div class="row">
      <div class="col-md-2 offset-md-1 configTab">
        <ul class="nav flex-column nav-pills nav-justified" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='configtopic'}" (click)="showTriangle('configtopic')">
            <a class="nav-link active tabBtn" id="v-pills-configtopic-tab" data-bs-toggle="tab" data-bs-target="#v-pills-configtopic"
              type="button" role="tab" aria-controls="v-pills-configtopic" aria-selected="true">Contract Type</a>
          </li>
          <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='category'}" (click)="showTriangle('category')">
            <a class="nav-link" id="v-pills-configCategory-tab" data-bs-toggle="tab" data-bs-target="#v-pills-configCategory"
              type="button" role="tab" aria-controls="v-pills-configCategory" aria-selected="true">Client Management</a>
          </li>
          </ul>
        </div>
    </div>       -->
</div>   